import { Controller } from "@hotwired/stimulus"
import { MapConfig } from "./map/map_config.js";
import { LocateControl } from "leaflet.locatecontrol";

export default class extends Controller {
  static targets = ["latitude", "longitude", "geolocation"];

  connect() {
    this.modalElement = this.element.closest('.modal');
    
    if (this.modalElement) {
      // Store the event handler for cleanup
      this.modalShownHandler = () => {
        if (!this.map) {
          setTimeout(() => { this.initializeMap(); }, 200);
        } else {
          // Invalidate size to handle container dimension changes
          this.map.invalidateSize();
        }
      }
      
      // Wait for modal to be shown before initializing map
      this.modalElement.addEventListener('shown.bs.modal', this.modalShownHandler);
    } else {
      // If not in modal, initialize immediately
      setTimeout(() => { this.initializeMap(); }, 300);
    }
  }

  initializeMap() {
    let self = this;

    // Determine center: form values > default Croatia
    let center;
    if (this.latitudeTarget.value && this.longitudeTarget.value) {
      center = [parseFloat(this.latitudeTarget.value), parseFloat(this.longitudeTarget.value)];
    } else {
      center = [45.815399, 15.981919]; // Default center (Croatia)
    }

    // Initialize map
    this.map = L.map(this.geolocationTarget).setView(center, 14);
  
    // Add OSM tile layer
    const osmConfig = MapConfig.getOSMTileLayerOptions();
    L.tileLayer(osmConfig.url, osmConfig.options).addTo(this.map);

    // Add scale control
    L.control.scale().addTo(this.map);

    // Create draggable marker for selected location
    if (this.latitudeTarget.value && this.longitudeTarget.value) {
      this.marker = L.marker(center, { draggable: true }).addTo(this.map);
      this.setupMarkerEvents();
    }

    // Add locate control button and automatically activate if user position is provided
    L.Control.GeoLocator = LocateControl.extend({
      _drawMarker: function () {
        LocateControl.prototype._drawMarker.call(this);
      }
    });
    
    const locateControl = new L.Control.GeoLocator({
      drawCircle: false,
      setView: false  // Don't automatically center map on user location
    }).addTo(this.map);
    
    // Automatically activate locate control 
    locateControl.start();

    // Listen for map clicks to set location
    this.map.on('click', function (e) {
      self.setLocation(e.latlng.lat, e.latlng.lng);
    });
  }

  setupMarkerEvents() {
    if (this.marker) {
      this.marker.on('dragend', (e) => {
        const position = e.target.getLatLng();
        this.updateInputs(position.lat, position.lng);
      })
    }
  }

  setLocation(lat, lng) {
    // Update or create marker for selected location
    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
    } else {
      this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
      this.setupMarkerEvents();
    }

    // Update form inputs
    this.updateInputs(lat, lng);
  }

  updateInputs(lat, lng) {
    this.latitudeTarget.value = lat.toFixed(6);
    this.longitudeTarget.value = lng.toFixed(6);
  }

  disconnect() {
    // Remove modal event listener if it exists
    if (this.modalElement && this.modalShownHandler) {
      this.modalElement.removeEventListener('shown.bs.modal', this.modalShownHandler);
    }

    if (this.map) { this.map.remove(); this.map = null; }

    if (this.marker) { this.marker = null; }
  }
}
